import React from 'react';
import { ListMacls as MaclComponent } from '~/components/Admin';

export function Macl() {
    return <MaclComponent />;
}
